<template>
  <div class="consumer-rights-success">
    <div class="success-body">
      <div class="success-header">
        <img
          class="success-icon"
          referrerpolicy="no-referrer"
          src="https://common-h5-dev.xiangshuheika.com/static/upload/202606255bf3d904baac1.png"
          alt="成功"
        />
        <div class="success-text-group">
          <span class="success-title">反馈已提交成功</span>
          <span class="success-desc">
            专员将在 1-3 个工作日内与您联系，请保持电话畅通
          </span>
        </div>
      </div>

      <div class="success-divider" />

      <div class="order-card">
        <div class="order-card-header">
          <span class="order-label">投诉工单编号：{{ orderNo }}</span>
          <button class="copy-btn" @click="copyOrderNo">复制工单号</button>
        </div>
        <div class="order-tip">
          <van-icon
            name="warn-o"
            style="margin-top: 4px; margin-right: 4px; flex-shrink: 0"
          />
          <p class="tip-text">
            <span class="tip-label">温馨提示</span>
            <span class="tip-content">
              ：请妥善留存工单编号及消费凭证，后续专员可能需要核验相关材料。
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clearFormCache } from "./utils";

export default {
  name: "consumerRightsSuccess",
  data() {
    return {
      orderNo: "",
    };
  },
  mounted() {
    clearFormCache();
    this.orderNo = this.$route.query.orderNo || "";
  },
  methods: {
    async copyOrderNo() {
      if (!this.orderNo) {
        this.$toast("暂无工单号");
        return;
      }
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.orderNo);
        } else {
          const input = document.createElement("input");
          input.value = this.orderNo;
          input.style.position = "fixed";
          input.style.opacity = "0";
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }
        this.$toast("复制成功");
      } catch {
        this.$toast("复制失败，请手动复制");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.consumer-rights-success {
  min-height: 100vh;
  background: #fff;
}

.success-body {
  padding: 40px 16px 0;
}

.success-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 31px;
}

.success-icon {
  width: 60px;
  height: 60px;
}

.success-text-group {
  margin-top: 16px;
  text-align: center;
}

.success-title {
  display: block;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  line-height: 22px;
}

.success-desc {
  display: block;
  margin-top: 12px;
  font-size: 12px;
  color: #666;
  line-height: 20px;
}

.success-divider {
  width: 295px;
  height: 1px;
  margin: 28px auto 0;
  background: url("https://lanhu-oss-2537-2.lanhuapp.com/SketchPng453ca939ba666193dafcf11a148108f9997b7840174f1eeb2b66e5c69e71ed61")
    no-repeat center;
  background-size: 100% 100%;
}

.order-card {
  margin-top: 18px;
  background: #f1f1f1;
  border-radius: 8px;
  padding: 12px;
}

.order-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.order-label {
  font-size: 12px;
  color: #333;
  line-height: 20px;
  flex: 1;
  word-break: break-all;
  padding-right: 8px;
}

.copy-btn {
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #0a84ff;
  font-size: 10px;
  line-height: 20px;
  cursor: pointer;
  padding: 0;
}

.order-tip {
  display: flex;
  align-items: flex-start;
}

.tip-icon {
  width: 12px;
  height: 12px;
  margin-top: 4px;
  margin-right: 4px;
  flex-shrink: 0;
}

.tip-text {
  margin: 0;
  font-size: 11px;
  line-height: 20px;
}

.tip-label {
  color: #666;
}

.tip-content {
  color: #999;
}
</style>
